import {Axios} from "axios";
import {z} from "zod";

export const updateCheckInStatusRequestSchema = z.object({
  data: z.object({
    eventId: z.number(),
    orderId: z.string(),
    checkInStatus: z.boolean(),
  }),
});
export type UpdateCheckInStatusRequestPayload = z.infer<
  typeof updateCheckInStatusRequestSchema
>;

export async function updateCheckInStatus(
  requestPayload: UpdateCheckInStatusRequestPayload,
  axiosInstance: Axios
) {
  updateCheckInStatusRequestSchema.parse(requestPayload);
  await axiosInstance.post(
    `event/${requestPayload.data.eventId}/order/checkIn`,
    requestPayload.data
  );
}
